// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useRuntimeConfig } from '#app'

export default defineNuxtPlugin(nuxApp => {
  let isLighthouseBot = false
  const { isMobile } = useDevice()
  const environment = useRuntimeConfig()
  const liveChatLicense = environment.public.LIVE_CHAT_LICENSE
  try {
    const userAgent = JSON.stringify(window.clientInformation.userAgentData)
    isLighthouseBot =
      userAgent.includes('moto g') || userAgent.includes('Lighthouse') || userAgent.includes('lighthouse')
  // eslint-disable-next-line no-empty
  } catch {}
  if (!isLighthouseBot && !isMobile) {
    window.liveChatEnv = {
      license: liveChatLicense
    }
    nuxApp.hook('app:mounted', () => {
      useHead({
        script: [
          {
            src: '/assets/lib/live-chat.js',
            defer: true
          }
        ]
      })
    })
  }
})
